import find from 'lodash/find';

import {
    CHANGE_DMARC_PASS_TYPE
} from './types/domain-portfolio-dmarc-selector-action-types';
import {
    selectedDmarcPassTypeSelector
} from '../../reports/selectors/reports-selectors';
import {
    dmarcPassTypeOptions
} from '../../reports/components/domain-portfolio/dmarc-pass-type-options';

import { getQueryParams, updateQueryParam } from '../../utils/query-param-utils';

export function changeDmarcPassType( dmarcPassType ){
    updateQueryParam( { dmarcPassType } );

    return {
        dmarcPassType,
        type: CHANGE_DMARC_PASS_TYPE,
    };
}

export function handleInitialLoad( dispatch, getState ){
    let { dmarcPassType } = getQueryParams();
    if( dmarcPassType ){
        if( !find( dmarcPassTypeOptions, { key: dmarcPassType } ) ){
            dmarcPassType = 'single';
        }
        dispatch( changeDmarcPassType( dmarcPassType ) );
    }
    else{
        const state = getState();
        const dmarcPassType = selectedDmarcPassTypeSelector( state );
        updateQueryParam( { dmarcPassType } );
    }
}

